var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "step_content" }, [
    _c(
      "div",
      {
        staticClass: "operation_wrapper",
        staticStyle: { "padding-top": "0px" },
      },
      [
        _c("h3", { staticClass: "task-name-info" }, [
          _vm._v("任务名称："),
          _c("span", { attrs: { title: _vm.taskName } }, [
            _vm._v(_vm._s(_vm.taskName)),
          ]),
        ]),
        _c("div", { staticClass: "titleBox" }, [
          _c("h3", { staticClass: "twoTitle" }, [_vm._v("双随机抽取结果表")]),
          _c(
            "div",
            { staticClass: "noticeBtn" },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text", disabled: _vm.alreadSend },
                  on: {
                    click: function ($event) {
                      return _vm.resultNoticeFn("2")
                    },
                  },
                },
                [_vm._v("通知执法检查人员")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "text", disabled: _vm.alreadSend },
                  on: {
                    click: function ($event) {
                      return _vm.resultNoticeFn("1")
                    },
                  },
                },
                [_vm._v("通知项目主体")]
              ),
            ],
            1
          ),
          _c("div", { staticClass: "twoTitleNav" }, [
            _c("span", [
              _vm._v("抽取人员： "),
              _c("span", [_vm._v(_vm._s(_vm.extractorName))]),
            ]),
            _c("span", [
              _vm._v("抽取完成时间： "),
              _c("span", [_vm._v(_vm._s(_vm.extractTime))]),
            ]),
          ]),
        ]),
        _c(
          "el-table",
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.dataListLoading,
                expression: "dataListLoading",
              },
            ],
            staticClass: "bigScreenTable",
            attrs: {
              stripe: "",
              data: _vm.tableData,
              height: _vm.tableMaxHeight,
              border: "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                fixed: "",
                label: "序号",
                type: "index",
                index: _vm.indexMethod,
                width: "50",
                align: "center",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "项目名称",
                prop: "bidSectionName",
                "header-align": "center",
                align: "left",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "项目编号",
                prop: "bidSectionCode",
                "header-align": "center",
                align: "left",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "项目类型",
                prop: "projectTypeName",
                align: "center",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: {
                label: "合同金额",
                width: "100",
                prop: "contractMoney",
                align: "center",
                "show-overflow-tooltip": true,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(_vm._s(scope.row.contractMoney + "（元）")),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "招标公告发布时间",
                prop: "tenderBulletinDate",
                align: "center",
                "min-width": "100",
                "show-overflow-tooltip": true,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(
                              scope.row.tenderBulletinDate,
                              "yyyy-MM-dd HH:mm:ss"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "合同签署时间",
                prop: "contractSignDate",
                "header-align": "center",
                align: "center",
                "min-width": "100",
                "show-overflow-tooltip": true,
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.formatDate(
                              scope.row.contractSignDate,
                              "yyyy-MM-dd HH:mm:ss"
                            )
                          )
                        ),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _c("el-table-column", {
              attrs: {
                label: "执法检查人员",
                prop: "executorsIdsName",
                "header-align": "center",
                align: "center",
                "min-width": "100",
                "show-overflow-tooltip": true,
              },
            }),
            _c("el-table-column", {
              attrs: { label: "操作", align: "center", width: "120" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      _c(
                        "el-button",
                        {
                          staticStyle: { color: "#00CCFF" },
                          attrs: {
                            type: "text",
                            size: "small",
                            title: "查看项目信息",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.routerDetail(scope.row)
                            },
                          },
                        },
                        [_vm._v("查看项目信息")]
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "btn_wraper", staticStyle: { padding: "0px 24px" } },
      [
        _c(
          "p",
          {
            staticClass: "supervisionNameInfo",
            staticStyle: { right: "66px" },
          },
          [_vm._v("监督检查单位：" + _vm._s(_vm.supervisionIdsName))]
        ),
        _c(
          "el-tooltip",
          {
            staticClass: "item",
            attrs: {
              "popper-class": "bigScreenPopper",
              "visible-arrow": false,
              effect: "light",
              placement: "top-start",
            },
          },
          [
            _c("div", { attrs: { slot: "content" }, slot: "content" }, [
              _vm._v(" " + _vm._s(_vm.supervisionIdsName) + " "),
            ]),
            _c(
              "el-button",
              { staticStyle: { float: "right" }, attrs: { type: "text" } },
              [_vm._v(" 更多> ")]
            ),
          ],
          1
        ),
        _c("el-button", { attrs: { plain: "" } }, [_vm._v("打印")]),
        _c(
          "el-button",
          {
            attrs: { plain: "" },
            on: {
              click: function ($event) {
                return _vm.prevStep()
              },
            },
          },
          [_vm._v("上一步")]
        ),
        _c(
          "el-button",
          {
            attrs: { type: "primary", plain: "" },
            on: {
              click: function ($event) {
                return _vm.handleClose()
              },
            },
          },
          [_vm._v("关闭")]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }